PegasusTemplate.BackgroundColorView = Ember.View.extend({
  templateName: 'background_color',
  classNames: ['background-color']
});
